import * as React from "react";
import styled, { css } from "styled-components";
import { Label } from "components/bootstrap";
const StatusLabel = styled(Label)(
  ({ $clickable }) => css`
    cursor: ${$clickable ? "pointer" : "default"};
    display: inline-flex;
    justify-content: center;
    gap: 4px;
  `
);
const FilterStatusCell = ({ filterOutputRule }) => {
  const isEnabled = filterOutputRule.status === "enabled";
  const title = isEnabled ? "Enabled" : "Disabled";
  return /* @__PURE__ */ React.createElement(
    StatusLabel,
    {
      bsStyle: isEnabled ? "success" : "warning",
      title,
      "aria-label": title,
      role: "button",
      $clickable: false
    },
    title
  );
};
export default FilterStatusCell;
